// Reserved writer-owned temporary basename, not a committed model resource.
// UUID v4 is exactly the suffix generated by crypto.randomUUID().
const STAGING_BASENAME = /^\.[^/]+\.staging-[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu;

export function createOpfsStagingFileName({ fileName }: { fileName: string }): string {
  return `.${fileName}.staging-${crypto.randomUUID()}`;
}

export function isOpfsStagingFileName({ fileName }: { fileName: string }): boolean {
  return STAGING_BASENAME.test(fileName);
}

export const TEST_ONLY = {
};
